import { GatewayRpcClient, GatewayRpcError } from './gateway-rpc'
import { ConfigSnapshot, ConfigSchemaResponse } from '../types'

export type ConfigPatchResponse = {
  ok: boolean
  path?: string
  config?: Record<string, unknown>
  hash?: string
  restart?: { scheduled: boolean; delayMs?: number }
}

export async function getConfig(client: GatewayRpcClient): Promise<ConfigSnapshot> {
  return client.call<ConfigSnapshot>('config.get', {})
}

export async function getSchema(client: GatewayRpcClient): Promise<ConfigSchemaResponse> {
  return client.call<ConfigSchemaResponse>('config.schema', {})
}

/**
 * Patch the Gateway config. The `raw` param must be a JSON string
 * (the Gateway parses it server-side via JSON5).
 */
export async function patchConfig(
  client: GatewayRpcClient,
  patch: Record<string, unknown>,
  baseHash: string
): Promise<ConfigPatchResponse> {
  return client.call<ConfigPatchResponse>('config.patch', {
    raw: JSON.stringify(patch),
    baseHash,
  })
}

/** Detect baseHash mismatch errors from config.patch */
export function isBaseHashConflictError(err: unknown): boolean {
  if (err instanceof GatewayRpcError) {
    return (
      err.code === 'INVALID_REQUEST' &&
      /config changed|hash mismatch/i.test(err.message)
    )
  }
  return false
}
